import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const SettingsManagersLazy = loadable(
    () => import(/* webpackChunkName: "SettingsLight" */ './SettingsManagersSuspense')
);

export const SettingsManagersAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <SettingsManagersLazy />
    </DelayedSuspense>
);
